export const computeIsSemrush = (isInIframe, isSemrushReferrer) => Boolean(isInIframe && isSemrushReferrer);

export const isInIframe = typeof window !== 'undefined' && window.self !== window.top;

export const isSemrushReferrer = (() => {
  if (typeof document === 'undefined') {
    return false;
  }

  try {
    const hostname = new URL(document.referrer).hostname;
    return hostname === 'semrush.com' || hostname.endsWith('.semrush.com');
  } catch {
    return false;
  }
})();

export const isSemrush = computeIsSemrush(isInIframe, isSemrushReferrer);
